import type { ExclusionMetricSummary } from "../types";

export function exclusionSummaryTotals(metrics: ExclusionMetricSummary[]) {
    const sum = (key: "excludedRecords" | "includedRecords" | "totalRecords") =>
        metrics.every(metric => metric[key] != null) ? metrics.reduce((total, metric) => total + metric[key]!, 0) : null;
    return { excludedRecords: sum("excludedRecords"), includedRecords: sum("includedRecords"), totalRecords: sum("totalRecords") };
}
